import { Injectable } from '@angular/core';
import { read } from 'xlsx';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {

  constructor() {
  }

  parseExcelFile(data: any) {
    const workbook = read(data, { dense: true });

    console.log(workbook.Sheets[workbook.SheetNames[0]]);
  }
}
